import type { CreatureState } from '@/domain/creature/types';

export type FoodId = 'meal' | 'snack' | 'fruit' | 'protein';
export type FoodCategory = 'healthy' | 'snack' | 'hearty';

export interface FoodDef {
  id: FoodId;
  category: FoodCategory;
  hungerDelta: number;
  happinessDelta: number;
  weightDelta: number;
}

const clamp = (n: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, n));

export const FOOD_CATALOG: Record<FoodId, FoodDef> = {
  meal: { id: 'meal', category: 'healthy', hungerDelta: 25, happinessDelta: 0, weightDelta: 1 },
  snack: { id: 'snack', category: 'snack', hungerDelta: 8, happinessDelta: 15, weightDelta: 3 },
  fruit: { id: 'fruit', category: 'healthy', hungerDelta: 16, happinessDelta: 5, weightDelta: 0 },
  protein: { id: 'protein', category: 'hearty', hungerDelta: 30, happinessDelta: -2, weightDelta: 2 },
};

export function canEatFood(state: CreatureState, foodId: FoodId): boolean {
  return FOOD_CATALOG[foodId].category === 'snack' || state.hunger <= 75;
}

export function applyFood(state: CreatureState, foodId: FoodId): CreatureState {
  const food = FOOD_CATALOG[foodId];
  return {
    ...state,
    hunger: clamp(state.hunger + food.hungerDelta, 0, 100),
    happiness: clamp(state.happiness + food.happinessDelta, 0, 100),
    weight: clamp(state.weight + food.weightDelta, 1, 99),
  };
}
